import React, { Fragment, useState, useEffect } from "react";
import { Col, Row, Card, CardBody } from "reactstrap";
import axios from "axios";
import { PortfolioTitle } from "../../Constant";
import { H4, P } from "../../AbstractElements";
import PagesSort from "./Pages";
import { Link } from "react-router-dom";
import { Gallery, Item } from "react-photoswipe-gallery";

const PhotosTab = () => {
  const description =
    "is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.";
  // eslint-disable-next-line no-unused-vars
  const [imagess, setImage] = useState([]);
  const [smallImages, setsmallImages] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.PUBLIC_URL}/api/image-light.json`)
      .then((response) => {
        setImage(response.data.src);
      });
    axios
      .get(`${process.env.PUBLIC_URL}/api/image-big-light.json`)
      .then((response) => {
        setsmallImages(response.data.src);
      });
  }, []);

  var images = require.context("../../assets/images", true);
  const dynamicImage = (image) => {
    return images(`./${image}`);
  };
  return (
    <Fragment>
      <Row>
        {smallImages && (
          <Col sm="12">
            <Card>
              <CardBody className="my-gallery gallery-with-description">
                <Row>
                  <Gallery>
                    {smallImages &&
                      smallImages.map((item, i) => {
                        return (
                          <figure className="col-xl-3 col-sm-6" key={i}>
                            <Item original={dynamicImage(item)} width="1024" height="768" caption="hello">
                              {({ ref, open }) => (
                                <Link onClick={open}>
                                  <img className="img-thumbnail" ref={ref} src={dynamicImage(item)} alt=""/>
                                  <div className="caption">
                                    <H4>{PortfolioTitle}</H4>
                                    <P>{description}</P>
                                  </div>
                                </Link>
                              )}
                            </Item>
                          </figure>
                        );
                      })}
                  </Gallery>
                </Row>
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>
      <PagesSort />
    </Fragment>
  );
};
export default PhotosTab;
